import React, { Component } from 'react';
import {
    Page,
    Card,
    BlockStack,
    Button,
    Text,
    Badge,
    Spinner,
    ProgressBar,
    Pagination,
    Checkbox,
    // Collapsible,
    Tooltip,
    Icon,
    SkeletonBodyText,
    // Layout,
    Popover,
    ActionList,
    Modal,

} from '@shopify/polaris';
import DOMPurify from 'dompurify';
import { withRouter } from 'react-router-dom';
import {
    reqGetBulkEditMetaTags,
    reqGetUpdBulkEditPreview,
    reqUpdBulkMetaConfig,
    reqGetRecord,
    reqGetMetaTagBatchOpt,
    reqUpdAloneBulkOpt,
    reqUpdBatchBulkOpt,
    reqSaveSwitchState,

} from '../../../api';
import { CancelMajor, MobileHorizontalDotsMajor } from '@shopify/polaris-icons';

// 获取全局公共数据
import { connect } from 'react-redux'
import { setPageData } from '../../../redux/actions/getAppPageData';
import SkeltonLoading from "../../../components/SkeltonLoading";
import './index.css';
import Switch from "react-switch";
import Language from '../../../i18n/Language';
import TableFilters from '../../../components/TableFilters';
import { cloneDeep, debounce } from 'lodash';
import FooterPageSelect from '../../../components/FooterPageSelect';
import FreeTagInputMix from '../../../components/FreeTagInput';
import FreeTagInputTraceless from '../../../components/FreeTagInput/indexV2';
import IndexTableMetaBox from './components/IndexTableMetaBox';
import utils from '../../../utils/utils';
import FaqCardBox from '../../../components/FaqCardBox';
import { setSaveSwitchData } from '../../../redux/actions/getAppPublicData';
import { store } from '../../../redux/store';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;

let timerArr = [], timeMetaArr = [], switchTimerArr = [];
// let count = 0;

class ManualBulkEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingTag: true,
            loadingPage: true,
            showToast: false,
            showToastText: '',
            showToastIserror: false,

            altProAutoAdd: false,                           // pro开关状态
            altColAutoAdd: false,                           // col开关状态
            altBlogAutoAdd: false,                          // blog开关状态
            productTitle: '',                               // 标题
            productDesc: '',                                // 描述
            collectionTitle: '',
            collectionDesc: '',
            blogTitle: '',
            blogDesc: '',
            productDescLength: 120,                         // 长度
            collectionDescLength: 120,
            blogDescLength: 120,
            productDeatial: false,                          // 预览详情
            colllectDeatial: false,
            blogDeatial: false,
            blogStatus: false,                              // 状态
            collectionStatus: false,
            productStatus: false,
            productRangeSliderStatus: false,                // 是否展示长度选择
            collectionRangeSliderStatus: false,
            blogRangeSliderStatus: false,
            altProAutoAddLoading: false,                    // 开关loading
            altColAutoAddLoading: false,
            altBlogAutoAddLoading: false,
            tagActive: [],                                  // 未填的tag数组
            proTitleTag: '',                                // tag字段
            proDescTag: '',
            colTitleTag: '',
            colDescTag: '',
            blogTitleTag: '',
            blogDescTag: '',
            ProductTitleTagBulkPop: false,                      // 下拉状态
            ProductDescTagBulkPop: false,
            ColTitleTagBulkPop: false,
            ColDescTagBulkPop: false,
            BlogTitleTagBulkPop: false,
            BlogDescTagBulkPop: false,

            productTitleList: [
                {
                    content: 'Product title',
                    onAction: () => this.addApplyField('Product title', 'ProductTitleTagBulk')
                },
                {
                    content: 'Product vendor',
                    onAction: () => this.addApplyField('Product vendor', 'ProductTitleTagBulk')
                },
                {
                    content: 'Product type',
                    onAction: () => this.addApplyField('Product type', 'ProductTitleTagBulk')
                },
                {
                    content: 'Price',
                    onAction: () => this.addApplyField('Price', 'ProductTitleTagBulk')
                },
                {
                    content: 'Shop name',
                    onAction: () => this.addApplyField('Shop name', 'ProductTitleTagBulk')
                },
                {
                    content: '2025',
                    onAction: () => this.addApplyField('2025', 'ProductTitleTagBulk')
                },
            ],
            productDescList: [
                {
                    content: 'Product title',
                    onAction: () => this.addApplyField('Product title', 'ProductDescTagBulk')
                },
                {
                    content: 'Product description',
                    onAction: () => this.addApplyField('Product description', 'ProductDescTagBulk')
                },
                {
                    content: 'Product vendor',
                    onAction: () => this.addApplyField('Product vendor', 'ProductDescTagBulk')
                },
                {
                    content: 'Product type',
                    onAction: () => this.addApplyField('Product type', 'ProductDescTagBulk')
                },
                {
                    content: 'Price',
                    onAction: () => this.addApplyField('Price', 'ProductDescTagBulk')
                },
                {
                    content: 'Shop name',
                    onAction: () => this.addApplyField('Shop name', 'ProductDescTagBulk')
                },
            ],
            colTitleList: [
                {
                    content: 'Collection title',
                    onAction: () => this.addApplyField('Collection title', 'ColTitleTagBulk')
                },
                {
                    content: 'Shop name',
                    onAction: () => this.addApplyField('Shop name', 'ColTitleTagBulk')
                }
            ],
            colDescList: [
                {
                    content: 'Collection title',
                    onAction: () => this.addApplyField('Collection title', 'ColDescTagBulk')
                },
                {
                    content: 'Collection description',
                    onAction: () => this.addApplyField('Collection description', 'ColDescTagBulk')
                },
                {
                    content: 'Shop name',
                    onAction: () => this.addApplyField('Shop name', 'ColDescTagBulk')
                }
            ],
            blogTitleList: [
                {
                    content: 'Article author',
                    onAction: () => this.addApplyField('Article author', 'BlogTitleTagBulk')
                },
                {
                    content: 'Article title',
                    onAction: () => this.addApplyField('Article title', 'BlogTitleTagBulk')
                },
                {
                    content: 'Article tags',
                    onAction: () => this.addApplyField('Article tags', 'BlogTitleTagBulk')
                },
                {
                    content: 'Shop name',
                    onAction: () => this.addApplyField('Shop name', 'BlogTitleTagBulk')
                }
            ],
            blogDescList: [
                {
                    content: 'Article author',
                    onAction: () => this.addApplyField('Article author', 'BlogDescTagBulk')
                },
                {
                    content: 'Article description',
                    onAction: () => this.addApplyField('Article description', 'BlogDescTagBulk')
                },
                {
                    content: 'Article tags',
                    onAction: () => this.addApplyField('Article tags', 'BlogDescTagBulk')
                },
                {
                    content: 'Article title',
                    onAction: () => this.addApplyField('Article title', 'BlogDescTagBulk')
                },
                {
                    content: 'Shop name',
                    onAction: () => this.addApplyField('Shop name', 'BlogDescTagBulk')
                }
            ],

            isShowProductPreview: false,
            isShowColPreview: false,
            isShowBlogPreview: false,
            productOverwrite: false,                // 覆盖状态
            collectionOverwrite: false,
            blogOverwrite: false,
            productSetLoading: false,               // 保存设置looaading
            collectionSetLoading: false,
            blogSetLoading: false,
            productSetDisabled: true,               // 保存设置disabled
            collectionSetDisabled: true,
            blogSetDisabled: true,
            page: 1,
            pageSize: 10,
            current_PageSize: 10,
            total: 0,
            queryValue: '',
            tabKey: 0,
            recordLoading: true,
            recordDataRes: {},
            recordData: [],
            recordHeadings: [
                { title: '' },
                { title: t("Name") },
                { title: t("Status") },
                { title: t("Optimized meta tags") },
                { title: t("Actions") },
            ],
            blHasPrevious: false,
            blHasNext: false,
            tableItemState: [],
            isShowSelected: true,
            isShowProgress: -1,
            progressCp: 0,
            progressAll: 0,
            optType: '',
            batchLoading: true,                     // 批量操作loading
            queryLoading: true,
            shopname: '', // 域名
            addTagsProTitle: '',
            addTagsProDesc: '',
            addTagsColTitle: '',
            addTagsColDesc: '',
            addTagsBlogTitle: '',
            addTagsBlogDesc: '',
            isLocalStorage: false,    // 是否无痕
            questionList: {
                w_meta: {
                    title: "What are the roles of meta titles and meta descriptions?",
                    tag: ["The meta title is a part of the HTML document's header, used to define the title of a webpage, which appears as the primary title on search engine results pages. The meta description is a part of the webpage's HTML code, providing a brief overview of the webpage's content, usually displayed on search engine results pages."]
                },
                n_change: {
                    title: "I need to know how long it will take to see the changes after setting them in SEO optimization.",
                    tag: ["The time it takes for changes to appear in Google search results varies depending on when Google crawls and indexes your webpage, typically resulting in changes appearing anywhere from a few days to a few weeks after modifications."],
                },
                h_meta: {
                    title: "How to use bulk edit for meta descriptions?",
                    tag: ["Set up rules for meta titles and meta descriptions for products, collections, and blogs, including concatenation of title variants, prices, etc., then save and turn on the switch. SEOAnt will automatically add them for you."]
                },
                wi_meta: {
                    title: "What information should be included in meta titles and meta descriptions?",
                    tag: ["Meta titles should contain relevant keywords and enticing descriptions related to the webpage's content, capable of attracting user clicks. Meta descriptions should succinctly summarize the webpage's content while including appealing keywords to improve click-through rates and search engine rankings."]
                },
                any_meta: {
                    title: "Are there any length restrictions for meta titles and meta descriptions?",
                    tag: ["Meta titles should typically be between 50 to 70 characters long to ensure complete display on search engine results pages. Meta descriptions should typically be between 150 to 200 characters long to ensure clear summaries are displayed in search results."]
                },
                had_meta: {
                    title: "How to avoid duplicate meta titles and meta descriptions?",
                    tag: ["Avoid duplicates between meta titles and meta descriptions, ensuring each page has unique titles and descriptions to attract different user groups and improve the overall visibility of the website."]
                },
                ssc_meta: {
                    title: "Should special characters or symbols be used in meta titles and meta descriptions?",
                    tag: ["To some extent, using special characters or symbols (such as arrows, asterisks, etc.) can attract user attention, but be cautious not to overuse them to avoid affecting readability and search engine parsing."]
                },
            },
            iscacheLoading: true, // 缓存状态
            level: 1,
            metaMoreState: false,
            productEditModal: false,
            collectionEditModal: false,
            blogEditModal: false,
            isShowCwAdverMetatag: false,      // 广告状态
        }

        // 防抖节流
        this.debounceGetRecordData = debounce(this.getRecordData, 500);
    }

    UNSAFE_componentWillMount() {
        let isLocalStorage = null;
        try {
            sessionStorage.setItem('localState', 1)
            isLocalStorage = true;
        } catch {
            isLocalStorage = false;
        }
        let switchData = this.props.public.publicInit.head_data?.switch_data;
        this.setState({
            isLocalStorage: isLocalStorage,
            isShowCwAdverMetatag: !Boolean(switchData?.cwAdverMetatagState),
        })
    }

    componentDidMount() {
        // 缓存
        let _page = this.props.page;
        this.setState({
            level: this.props.public.level
        }, () => {
            this.getRecordData();
            this.geBulkEditUserConfig(_page.pageInit?.MetaTags);
        })
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.userServices !== this.state.userServices) {
            this.setState({
                userServices: nextProps.userServices,
            })
        }
        return true
    }

    // 获取历史记录
    getRecordData = async (isLoading = true, queryLoading = false, isBatch = true) => {
        if (isLoading) {
            this.setState({ recordLoading: true })
        }
        if (queryLoading) {
            this.setState({ queryLoading: true })
        }
        let { page, pageSize, queryValue, tabKey } = this.state;
        let params = {
            page: page,
            size: pageSize,
            select: queryValue,
            type: tabKey + 1,
        }
        const res = await reqGetRecord(params);
        if (res.ack === 1) {
            let lists = cloneDeep(res);
            lists['data']['list'].forEach(item => {
                item['restoreLoading'] = -1;
                item['optLoading'] = -1;
            })
            this.setState({
                recordLoading: false,
                recordData: lists.data.list,
                recordDataRes: lists,
                total: res.data.count,
                blHasPrevious: page > 1 ? true : false,
                blHasNext: Math.ceil(res.data.count / pageSize) > page ? true : false,
                batchLoading: false,
                queryLoading: false,
            }, () => {
                if (isBatch) {
                    this.getMetaTagBatchOpt();
                }
            })
        } else {
            this.props.toggleToast(res.msg, true)
        }
    }


    // 获取并更新页面数据
    geBulkEditUserConfig = (cache = null) => {
        // 关闭加载框
        this.setState({
            loading: false,
        }, async () => {
            let response = cache || await reqGetBulkEditMetaTags();
            this.props.getPageDataRedux(response);
            if (response.code === 200) {
                let t = response.data;
                this.setState({
                    altOn: true,//默认打开 字段保留
                    productOn: true,//默认打开 字段保留
                    collectionsOn: true,//默认打开 字段保留
                    blogOn: true,//默认打开 字段保留
                    loadingPage: false,

                    altProAutoAdd: Boolean(t.product_while_create),                 // product alt auto add setting
                    altColAutoAdd: Boolean(t.collection_while_create),              // collection alt auto add setting
                    altBlogAutoAdd: Boolean(t.blog_while_create),                   // blog alt auto add setting

                    productTitle: t.product_title,                                  //product meta title
                    productDesc: t.product_desc,                                    //produtct meta description 
                    collectionTitle: t.collection_title,                            //collection meta title
                    collectionDesc: t.collection_desc,                              //collection meta desc
                    blogTitle: t.blog_title,                                        //blog meta title 
                    blogDesc: t.blog_desc,                                          //blog meta desc

                    proTitleTag: this.formatTagData('proTitle', t.product_title),               // tag字段
                    proDescTag: this.formatTagData('proDesc', t.product_desc),
                    colTitleTag: this.formatTagData('colTitle', t.collection_title),
                    colDescTag: this.formatTagData('colDesc', t.collection_desc),
                    blogTitleTag: this.formatTagData('blogTitle', t.blog_title),
                    blogDescTag: this.formatTagData('blogDesc', t.blog_desc),

                    productDescLength: Boolean(t.product_desc_rule_length) ? t.product_desc_rule_length : 120,
                    collectionDescLength: Boolean(t.collection_desc_rule_length) ? t.collection_desc_rule_length : 120,
                    blogDescLength: Boolean(t.blog_desc_rule_length) ? t.blog_desc_rule_length : 120,

                    productDeatial: JSON.parse(response.data.productDeatial),
                    colllectDeatial: JSON.parse(response.data.colllectDeatial),
                    blogDeatial: JSON.parse(response.data.blogDeatial),
                    shopname: JSON.parse(response.data.productDeatial)['shopname'],
                    blogStatus: response.data.blogStatus,
                    collectionStatus: response.data.collectionStatus,
                    productStatus: response.data.productStatus,
                    productOverwrite: Boolean(response.data.product_overwrite),
                    collectionOverwrite: Boolean(response.data.collection_overwrite),
                    blogOverwrite: Boolean(response.data.blog_overwrite),
                    iscacheLoading: cache || false,
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            loadingTag: false,
                        })
                    }, 100)

                    this.getNewRecordInfo();
                });

                // if (response.data.optimizeProduct || response.data.optimizeCollection || response.data.optimizeBlog) {
                //     let t = response.data;
                //     let type = t.optimizeProduct ? 'Products' : t.optimizeCollection ? 'Collections' : t.optimizeBlog ? 'Blogs' : '';
                //     this.getOptimizeStatus(type, response.data);
                // }

                // 获取缓存后继续请求接口新数据
                if (cache) {
                    this.geBulkEditUserConfig();
                }

                // 更新新手引导状态
                let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
                if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
                    data.manual_guide.meta_tag = { "at": Math.floor(new Date().getTime() / 1000), "st": 1 };
                    store.dispatch(setSaveSwitchData(data));
                }
            }
        });
    }

    // 判断是否轮询
    getNewRecordInfo = () => {
        let t = this.state;
        if ((Boolean(t.altProAutoAdd) && t.tabKey === 0) || (Boolean(t.altColAutoAdd) && t.tabKey === 1) || (Boolean(t.altBlogAutoAdd) && t.tabKey === 2)) {
            if (timeMetaArr.length === 0 && switchTimerArr.length === 0) {
                let timer = setInterval(() => {
                    this.getRecordData(false, false, false);
                }, 5000)
                switchTimerArr.push(timer);
            }
        } else {
            this.deleteSwitchTimerArr();
        }
    }

    // 格式化tag数据
    formatTagData = (type, data) => {
        let val = "";
        if (Boolean(data) && data !== '') {
            val = cloneDeep(data);
            val = val.replace(/\n/g, '');
            if (type === 'proTitle') {
                val = val.replace(/%product_title%/g, '[[{"value":"Product title"}]]')
                    .replace(/%product_vendor%/g, '[[{"value":"Product vendor"}]]')
                    .replace(/%product_type%/g, '[[{"value":"Product type"}]]')
                    .replace(/%price%/g, '[[{"value":"Price"}]]')
                    .replace(/%shopname%/g, '[[{"value":"Shop name"}]]')
                    .replace(/2025/g, '[[{"value":"2025"}]]');
            } else if (type === 'proDesc') {
                val = val.replace(/%product_title%/g, '[[{"value":"Product title"}]]')
                    .replace(/%product_description%/g, '[[{"value":"Product description"}]]')
                    .replace(/%product_vendor%/g, '[[{"value":"Product vendor"}]]')
                    .replace(/%product_type%/g, '[[{"value":"Product type"}]]')
                    .replace(/%price%/g, '[[{"value":"Price"}]]')
                    .replace(/%shopname%/g, '[[{"value":"Shop name"}]]');
            } else if (type === 'colTitle') {
                val = val.replace(/%collection_title%/g, '[[{"value":"Collection title"}]]')
                    .replace(/%shopname%/g, '[[{"value":"Shop name"}]]');
            } else if (type === 'colDesc') {
                val = val.replace(/%collection_title%/g, '[[{"value":"Collection title"}]]')
                    .replace(/%collection_description%/g, '[[{"value":"Collection description"}]]')
                    .replace(/%shopname%/g, '[[{"value":"Shop name"}]]');
            } else if (type === 'blogTitle') {
                val = val.replace(/%article_author%/g, '[[{"value":"Article author"}]]')
                    .replace(/%article_title%/g, '[[{"value":"Article title"}]]')
                    .replace(/%article_tags%/g, '[[{"value":"Article tags"}]]')
                    .replace(/%shopname%/g, '[[{"value":"Shop name"}]]');
            } else {
                val = val.replace(/%article_author%/g, '[[{"value":"Article author"}]]')
                    .replace(/%article_description%/g, '[[{"value":"Article description"}]]')
                    .replace(/%article_title%/g, '[[{"value":"Article title"}]]')
                    .replace(/%article_tags%/g, '[[{"value":"Article tags"}]]')
                    .replace(/%shopname%/g, '[[{"value":"Shop name"}]]');
            }
        }
        return val;
    }

    //更新预览内容
    updBulkEditPreview = async (type) => {
        if (type === 1) {
            this.setState({
                updProductPreviewStatus: true
            })
        } else if (type === 2) {
            this.setState({
                updCollectionPreviewStatus: true
            })
        } else if (type === 3) {
            this.setState({
                updBlogPreviewStatus: true
            })
        }
        let params = {
            type: type
        }
        const res = await reqGetUpdBulkEditPreview(params);
        if (res) {
            if (type === 1) {
                this.setState({
                    updProductPreviewStatus: false,
                })
            } else if (type === 2) {
                this.setState({
                    updCollectionPreviewStatus: false,
                })
            } else if (type === 3) {
                this.setState({
                    updBlogPreviewStatus: false,
                })
            }
            if (res.code === 200) {
                this.props.toggleToast(res.msg, false);
                if (type === 1) {
                    this.setState({
                        productDeatial: JSON.parse(res.data),
                        productStatus: true,
                    })
                } else if (type === 2) {
                    this.setState({
                        colllectDeatial: JSON.parse(res.data),
                        collectionStatus: true,
                    })
                } else if (type === 3) {
                    this.setState({
                        blogDeatial: JSON.parse(res.data),
                        blogStatus: true,
                    })
                }
            } else {
                this.props.toggleToast(res.msg, true);
            }
        }
    }

    // 选择对应字段
    addApplyField = (type, name) => {
        let { proTitleTag, proDescTag, colTitleTag, colDescTag, blogTitleTag, blogDescTag } = this.state;
        // 删除对应提示
        let curActive = cloneDeep(this.state.tagActive);
        if (curActive.includes(name)) {
            curActive.splice(curActive.indexOf(name), 1);
        }
        // 对象赋值
        let setObj =
            name === 'ProductTitleTagBulk' ? {
                proTitleTag: !Boolean(proTitleTag?.length) ? `[[{"value":"${type}"}]]` : `${proTitleTag} [[{"value":"${type}"}]]`,
                addTagsProTitle: !Boolean(proTitleTag?.length) ? `[[{"value":"${type}"}]]` : `${proTitleTag} [[{"value":"${type}"}]]`,
            } :
                name === 'ProductDescTagBulk' ? {
                    proDescTag: !Boolean(proDescTag?.length) ? `[[{"value":"${type}"}]]` : `${proDescTag} [[{"value":"${type}"}]]`,
                    addTagsProDesc: !Boolean(proDescTag?.length) ? `[[{"value":"${type}"}]]` : `${proDescTag} [[{"value":"${type}"}]]`,
                } :
                    name === 'ColTitleTagBulk' ? {
                        colTitleTag: !Boolean(colTitleTag?.length) ? `[[{"value":"${type}"}]]` : `${colTitleTag} [[{"value":"${type}"}]]`,
                        addTagsColTitle: !Boolean(colTitleTag?.length) ? `[[{"value":"${type}"}]]` : `${colTitleTag} [[{"value":"${type}"}]]`,
                    } :
                        name === 'ColDescTagBulk' ? {
                            colDescTag: !Boolean(colDescTag?.length) ? `[[{"value":"${type}"}]]` : `${colDescTag} [[{"value":"${type}"}]]`,
                            addTagsColDesc: !Boolean(colDescTag?.length) ? `[[{"value":"${type}"}]]` : `${colDescTag} [[{"value":"${type}"}]]`,
                        } :
                            name === 'BlogTitleTagBulk' ? {
                                blogTitleTag: !Boolean(blogTitleTag?.length) ? `[[{"value":"${type}"}]]` : `${blogTitleTag} [[{"value":"${type}"}]]`,
                                addTagsBlogTitle: !Boolean(blogTitleTag?.length) ? `[[{"value":"${type}"}]]` : `${blogTitleTag} [[{"value":"${type}"}]]`,
                            } :
                                name === 'BlogDescTagBulk' ? {
                                    blogDescTag: !Boolean(blogDescTag?.length) ? `[[{"value":"${type}"}]]` : `${blogDescTag} [[{"value":"${type}"}]]`,
                                    addTagsBlogDesc: !Boolean(blogDescTag?.length) ? `[[{"value":"${type}"}]]` : `${blogDescTag} [[{"value":"${type}"}]]`,
                                } : {};

        setObj[`${name}Pop`] = !Boolean(this.state[`${name}Pop`]);
        setObj['tagActive'] = curActive;
        this.setState(setObj, () => {
            // this.$name.addInputTag(name);
            let type = ['ProductTitleTagBulk', 'ProductDescTagBulk'].includes(name) ? 'product' : ['ColTitleTagBulk', 'ColDescTagBulk'].includes(name) ? 'collection' : 'blog';
            this.setSaveSetState(type);
        })

    }

    // 获取tag输入框对象
    setTagifyData = (data, name) => {
        this.setState({
            [name]: data[0],
        })
        this.$name = data[1];
    }

    // 输入
    tagInputData = debounce((e, name) => {
        let curActive = cloneDeep(this.state.tagActive);
        const tagCompare = {
            proTitleTag: "ProductTitleTagBulk",
            proDescTag: "ProductDescTagBulk",
            colTitleTag: "ColTitleTagBulk",
            colDescTag: "ColDescTagBulk",
            blogTitleTag: "BlogTitleTagBulk",
            blogDescTag: "BlogDescTagBulk",
        }
        if (curActive.includes(tagCompare[name])) {
            curActive.splice(curActive.indexOf(tagCompare[name]), 1);
        }
        let value = "";
        if (e.type === "input") {
            value = e.detail.textContent;
            if (e.detail.tagify.value.length > 0) {
                e.detail.tagify.value.forEach(item => {
                    value = value.replace(new RegExp(`(?<!")${item.value}(?!")`, 'g'), `[[{"value":"${item.value}"}]]`)
                })
            }
        } else {
            value = e.detail?.value;
            if (e.type === "remove") {
                value = e.detail.tagify.state.lastOriginalValueReported;
            }
        }
        this.setState({
            [name]: Boolean(value) ? value.replace(/[\n\u200B]/g, "") : '',
            tagActive: curActive,
        })
        if (e.type !== "change" || (Boolean(e.target?.value) && e.target.value.replace(/[\n\u200B]/g, '') !== this.state[name])) {
            let type = ['proTitleTag', 'proDescTag'].includes(name) ? 'product' : ['colTitleTag', 'colDescTag'].includes(name) ? 'collection' : 'blog';
            this.setSaveSetState(type);
        }
    }, 100)


    // 无痕模式 - 输入
    tagInputDataTraceless = (val, name) => {
        let curActive = cloneDeep(this.state.tagActive);
        const tagCompare = {
            proTitleTag: "ProductTitleTagBulk",
            proDescTag: "ProductDescTagBulk",
            colTitleTag: "ColTitleTagBulk",
            colDescTag: "ColDescTagBulk",
            blogTitleTag: "BlogTitleTagBulk",
            blogDescTag: "BlogDescTagBulk",
        }
        const tagTypes = {
            proTitleTag: "proTitle",
            proDescTag: "proDesc",
            colTitleTag: "colTitle",
            colDescTag: "colDesc",
            blogTitleTag: "blogTitle",
            blogDescTag: "blogDesc",
        }
        if (curActive.includes(tagCompare[name])) {
            curActive.splice(curActive.indexOf(tagCompare[name]), 1);
        }
        let tagVal = this.formatTagData(tagTypes[name], val);
        this.setState({
            [name]: Boolean(tagVal) ? tagVal.replace(/[\n\u200B]/g, "") : '',
            tagActive: curActive,
        })
        let type = ['proTitleTag', 'proDescTag'].includes(name) ? 'product' : ['colTitleTag', 'colDescTag'].includes(name) ? 'collection' : 'blog';
        this.setSaveSetState(type);
    }

    // 改变tag下拉框状态
    changeSelectPop = (id) => {
        let name = `${id}Pop`;
        const tagState = {
            ProductTitleTagBulkPop: false,
            ProductDescTagBulkPop: false,
            ColTitleTagBulkPop: false,
            ColDescTagBulkPop: false,
            BlogTitleTagBulkPop: false,
            BlogDescTagBulkPop: false,
        }
        tagState[name] = !Boolean(this.state[name]);
        this.setState(tagState);
    }

    // 打开预览
    openPreview = (name) => {
        this.setState({
            [name]: !this.state[name]
        })
    }

    // 覆盖状态
    checkOverwriteState = (val, name) => {
        this.setState({
            [name]: val,
        }, () => {
            let type = name === 'productOverwrite' ? 'product' : name === 'collectionOverwrite' ? 'collection' : 'blog';
            this.setSaveSetState(type);
        });
    }

    // 修改保存状态
    setSaveSetState = (type) => {
        if (type === 'product') {
            this.setState({
                productSetDisabled: false,
            })
        }
        if (type === 'collection') {
            this.setState({
                collectionSetDisabled: false,
            })
        }
        if (type === 'blog') {
            this.setState({
                blogSetDisabled: false,
            })
        }
    }

    // 打开对应开关
    autoSwitchChange = (name) => {
        //查询用户服务开关
        if (this.state.userServices.BulkEditMetaTags === false) {
            this.props.show();
            return false;
        }
        this.setState({
            [name]: !this.state[name],
            [`${name}Loading`]: true,
        }, async () => {
            let { proTitleTag, proDescTag, colTitleTag, colDescTag, blogTitleTag, blogDescTag, altProAutoAdd, altColAutoAdd, altBlogAutoAdd, productOverwrite, collectionOverwrite, blogOverwrite } = this.state;
            let params = {};
            let tagActive = [];
            let type = name === 'altProAutoAdd' ? 1 : name === 'altColAutoAdd' ? 2 : 3;
            if (name === 'altProAutoAdd') {
                if (!Boolean(proTitleTag.replace(/[\n\u200B]/g, ''))) {
                    tagActive.push('ProductTitleTagBulk');
                }
                if (!Boolean(proDescTag.replace(/[\n\u200B]/g, ''))) {
                    tagActive.push('ProductDescTagBulk');
                }
                params = {
                    type,
                    title: this.changeTagFormat(proTitleTag, 'proTitle'),
                    desc: this.changeTagFormat(proDescTag, 'proDesc'),
                    is_auto: Number(altProAutoAdd),
                    is_over: Number(productOverwrite),
                }
            } else if (name === 'altColAutoAdd') {
                if (!Boolean(colTitleTag.replace(/[\n\u200B]/g, ''))) {
                    tagActive.push('ColTitleTagBulk');
                }
                if (!Boolean(colDescTag.replace(/[\n\u200B]/g, ''))) {
                    tagActive.push('ColDescTagBulk');
                }
                params = {
                    type,
                    title: this.changeTagFormat(colTitleTag, 'colTitle'),
                    desc: this.changeTagFormat(colDescTag, 'colDesc'),
                    is_auto: Number(altColAutoAdd),
                    is_over: Number(collectionOverwrite),
                }
            } else {
                // altBlogAutoAdd
                if (!Boolean(blogTitleTag.replace(/[\n\u200B]/g, ''))) {
                    tagActive.push('BlogTitleTagBulk');
                }
                if (!Boolean(blogDescTag.replace(/[\n\u200B]/g, ''))) {
                    tagActive.push('BlogDescTagBulk');
                }
                params = {
                    type,
                    title: this.changeTagFormat(blogTitleTag, 'blogTitle'),
                    desc: this.changeTagFormat(blogDescTag, 'blogDesc'),
                    is_auto: Number(altBlogAutoAdd),
                    is_over: Number(blogOverwrite),
                }
            }
            this.setState({
                tagActive,
            })
            if (tagActive.length > 0) {
                this.setState({
                    [name]: !this.state[name],
                    [`${name}Loading`]: false,
                })
                // this.props.toggleToast('The input value cannot be empty', false);
                return false;
            }
            const res = await reqUpdBulkMetaConfig(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false)
                let disabledBtn = type === 1 ? 'productSetDisabled' : type === 2 ? 'collectionSetDisabled' : 'blogSetDisabled';
                this.setState({
                    [disabledBtn]: true
                })

                // 判断是否要轮询
                if (this.state[name]) {
                    this.getNewRecordInfo();
                } else {
                    this.deleteSwitchTimerArr();
                }
            } else {
                this.props.toggleToast(res.msg, true)
                this.setState({
                    [name]: !this.state[name],
                })
            }

            if (res) {
                this.setState({
                    [`${name}Loading`]: false,
                })
            }
        })
    }

    // 保存设置
    saveSettingData = async (type, modal) => {
        //查询用户服务开关
        if (this.state.userServices.BulkEditMetaTags === false) {
            this.props.show();
            return false;
        }
        let { proTitleTag, proDescTag, colTitleTag, colDescTag, blogTitleTag, blogDescTag, altProAutoAdd, altColAutoAdd, altBlogAutoAdd, productOverwrite, collectionOverwrite, blogOverwrite } = this.state;
        let params = {};
        let tagActive = [];
        if (type === 'productSet') {
            if (!Boolean(proTitleTag.replace(/[\n\u200B]/g, ''))) {
                tagActive.push('ProductTitleTagBulk');
            }
            if (!Boolean(proDescTag.replace(/[\n\u200B]/g, ''))) {
                tagActive.push('ProductDescTagBulk');
            }
            params = {
                type: 1,
                title: this.changeTagFormat(proTitleTag, 'proTitle'),
                desc: this.changeTagFormat(proDescTag, 'proDesc'),
                is_auto: Number(altProAutoAdd),
                is_over: Number(productOverwrite),
            }
        } else if (type === 'collectionSet') {
            if (!Boolean(colTitleTag.replace(/[\n\u200B]/g, ''))) {
                tagActive.push('ColTitleTagBulk');
            }
            if (!Boolean(colDescTag.replace(/[\n\u200B]/g, ''))) {
                tagActive.push('ColDescTagBulk');
            }
            params = {
                type: 2,
                title: this.changeTagFormat(colTitleTag, 'colTitle'),
                desc: this.changeTagFormat(colDescTag, 'colDesc'),
                is_auto: Number(altColAutoAdd),
                is_over: Number(collectionOverwrite),
            }
        } else {
            // altBlogAutoAdd
            if (!Boolean(blogTitleTag.replace(/[\n\u200B]/g, ''))) {
                tagActive.push('BlogTitleTagBulk');
            }
            if (!Boolean(blogDescTag.replace(/[\n\u200B]/g, ''))) {
                tagActive.push('BlogDescTagBulk');
            }
            params = {
                type: 3,
                title: this.changeTagFormat(blogTitleTag, 'blogTitle'),
                desc: this.changeTagFormat(blogDescTag, 'blogDesc'),
                is_auto: Number(altBlogAutoAdd),
                is_over: Number(blogOverwrite),
            }
        }
        this.setState({
            tagActive,
        })
        if (tagActive.length > 0) {
            // this.props.toggleToast('The input value cannot be empty', false);
            return false;
        }
        let types = type === 'productSet' ? 'productSetLoading' : type === 'collectionSet' ? 'collectionSetLoading' : 'blogSetLoading'; // 按钮loading
        let typeDis = type === 'productSet' ? 'productSetDisabled' : type === 'collectionSet' ? 'collectionSetDisabled' : 'blogSetDisabled'; // 按钮禁止
        this.setState({
            [types]: true,
        })
        const res = await reqUpdBulkMetaConfig(params);
        if (res.ack === 1) {
            this.props.toggleToast(res.msg, false);
            this.setState({
                [typeDis]: true,
                [modal]: false,
            }, () => {
                this.geBulkEditUserConfig();
            })
        } else {
            this.props.toggleToast(res.msg, true)
        }
        if (res) {
            this.setState({
                [types]: false,
            })
        }
    }

    // 格式化tag数据
    changeTagFormat = (data, type) => {
        let val = cloneDeep(data);
        val = val.replace(/[\n\u200B]/g, '');
        if (type === 'proTitle') {
            val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%')
                .replace(/\[\[{"value":"2025"}\]\]/g, '2025')
        } else if (type === 'proDesc') {
            val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                .replace(/\[\[{"value":"Product description"}\]\]/g, '%product_description%')
                .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
        } else if (type === 'colTitle') {
            val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
        } else if (type === 'colDesc') {
            val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                .replace(/\[\[{"value":"Collection description"}\]\]/g, '%collection_description%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
        } else if (type === 'blogTitle') {
            val = val.replace(/\[\[{"value":"Article author"}\]\]/g, '%article_author%')
                .replace(/\[\[{"value":"Article title"}\]\]/g, '%article_title%')
                .replace(/\[\[{"value":"Article tags"}\]\]/g, '%article_tags%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
        } else if (type === 'blogDesc') {
            val = val.replace(/\[\[{"value":"Article author"}\]\]/g, '%article_author%')
                .replace(/\[\[{"value":"Article description"}\]\]/g, '%article_description%')
                .replace(/\[\[{"value":"Article title"}\]\]/g, '%article_title%')
                .replace(/\[\[{"value":"Article tags"}\]\]/g, '%article_tags%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
        } else { }
        return val;
    }

    // 页面所属类型 切换
    handleTypeTabsChange = (selectedTabIndex) => {
        this.setState({
            tabKey: selectedTabIndex,
            page: 1,
            pageSize: 10,
            current_PageSize: 10,
            recordLoading: true,
            isShowProgress: -1,
            optType: '',
            queryValue: '',
        }, () => {
            this.getRecordData();
            this.getNewRecordInfo();
        })
    };
    // 搜索
    setQueryValue = (v) => {
        this.setState({
            queryValue: v,
            page: 1,
            pageSize: 10,
            current_PageSize: 10,
        }, () => {
            this.debounceGetRecordData(false, true, false);
        })
    }

    // 选择分类
    setIssueTypeChange = (e) => {
        if (Boolean(window.onpageEvent)) {
            if (e === -1) {
                window.onpageEvent.selectIssueData();
            } else {
                window.onpageEvent.selectIssueData(e[0]);
            }
        }
    }

    // 使用默认规则
    setDefaultRule = (type) => {
        // 删除对应提示
        const tagCompare = {
            proTitleTag: "ProductTitleTagBulk",
            proDescTag: "ProductDescTagBulk",
            colTitleTag: "ColTitleTagBulk",
            colDescTag: "ColDescTagBulk",
            blogTitleTag: "BlogTitleTagBulk",
            blogDescTag: "BlogDescTagBulk",
        }
        let curActive = cloneDeep(this.state.tagActive);
        if (curActive.includes(tagCompare[type])) {
            curActive.splice(curActive.indexOf(tagCompare[type]), 1);
        }
        const TagList = {
            proTitleTag: `[[{"value":"Product title"}]] - [[{"value":"Shop name"}]]`,
            proDescTag: `[[{"value":"Product description"}]] - [[{"value":"Shop name"}]]`,
            colTitleTag: `[[{"value":"Collection title"}]] - [[{"value":"Shop name"}]]`,
            colDescTag: `[[{"value":"Collection description"}]] - [[{"value":"Shop name"}]]`,
            blogTitleTag: `[[{"value":"Article title"}]] - [[{"value":"Shop name"}]]`,
            blogDescTag: `[[{"value":"Article description"}]] - [[{"value":"Shop name"}]]`,
        }
        const addTypes = {
            proTitleTag: `addTagsProTitle`,
            proDescTag: `addTagsProDesc`,
            colTitleTag: `addTagsColTitle`,
            colDescTag: `addTagsColDesc`,
            blogTitleTag: `addTagsBlogTitle`,
            blogDescTag: `addTagsBlogDesc`,
        }
        this.props.toggleToast(t("Success"), false);
        let disabledBtn = ['proTitleTag', 'proDescTag'].includes(type) ? 'productSetDisabled' : ['colTitleTag', 'colDescTag'].includes(type) ? 'collectionSetDisabled' : 'blogSetDisabled';
        if (this.state[type] === TagList[type]) {
            this.setState({
                [disabledBtn]: false,
            })
        } else {
            let tagName = addTypes[type];
            this.setState({
                [type]: TagList[type],
                [tagName]: '',
                [disabledBtn]: false,
            }, () => {
                this.setState({
                    [tagName]: TagList[type],
                })
            })
        }

        this.setState({
            tagActive: curActive
        })
    }

    // 改变页面条数
    changePageSizeData = (s) => {
        this.setState({
            page: 1,
            pageSize: Number(s),
            current_PageSize: Number(s),
            recordLoading: true,
        }, () => {
            this.getRecordData();
        })
    }

    // 分页
    changeTablePage = (page) => {
        this.setState({
            page,
        }, () => {
            this.getRecordData();
        })
    }

    // 表格选择数量状态
    getTableItemState = (val) => {
        this.setState({
            tableItemState: val
        })
    }

    // 单个恢复 | 优化
    aloneBatchOpt = (obj, type) => {
        //查询用户服务开关
        if (this.state.userServices.BulkEditMetaTags === false) {
            this.props.show();
            return false;
        }
        let { tabKey, recordData } = this.state;
        let list = cloneDeep(recordData);
        list.forEach(item => {
            if (item['id'] === obj['id']) {
                if (type === 'restore') {
                    item['restoreLoading'] = item['id'];
                } else {
                    item['optLoading'] = item['id'];
                }
            }
        })
        this.setState({
            recordData: list,
        }, async () => {
            let params = {
                type: tabKey + 1,
                opt: type === 'restore' ? 0 : 1,
                id: obj.id,
            }
            const res = await reqUpdAloneBulkOpt(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                this.getRecordData(false);
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    }

    // 获取优化记录进度
    getMetaTagBatchOpt = async () => {
        let { tabKey } = this.state;
        let params = {
            type: tabKey + 1
        }
        const res = await reqGetMetaTagBatchOpt(params);
        if (res.ack === 1) {
            this.setState({
                progressCp: res.data.completed,
                progressAll: res.data.total,
                optType: res.data.opt === 0 ? 'restored' : 're-optimized'
            }, () => {
                if (res.data.is_pop === 1) {
                    this.deleteMetaTimerArr();
                    this.props.toggleToast(`${res.data.total} ${tabKey === 0 ? 'products' : tabKey === 1 ? 'collections' : 'blogs'} ${res.data.opt === 0 ? 'restored' : 're-optimized'}`, false);
                    this.setState({
                        isShowProgress: -1,
                        progressCp: 0,
                        progressAll: 0,
                    }, () => {
                        setTimeout(() => {
                            this.getRecordData();
                            this.getNewRecordInfo();
                        }, 3000)
                    })
                } else if (res.data.status === 0 || res.data.completed !== res.data.total) {
                    this.setState({
                        isShowProgress: tabKey,
                    })
                    if (timeMetaArr.length === 0) {
                        let timer = setInterval(() => {
                            this.getRecordData(false);
                        }, 5000)
                        timeMetaArr.push(timer)
                    }
                } else {
                    this.deleteMetaTimerArr();
                }
            })

        } else {
            this.props.toggleToast(res.msg, true)
        }
    }

    // 批量操作
    handleObjState = (type) => {
        //查询用户服务开关
        if (this.state.userServices.BulkEditMetaTags === false) {
            this.props.show();
            return false;
        }
        let { tabKey, tableItemState } = this.state;
        this.setState({
            isShowProgress: tabKey,
            progressCp: 0,
            progressAll: 0,
            optType: type,
            batchLoading: true
        }, async () => {
            let params = {
                type: tabKey + 1,
                is_all: tableItemState[1] ? 1 : 0,
                opt: type === 'restore' ? 0 : 1,
                ids: tableItemState[1] ? [] : tableItemState[0],
            }
            const res = await reqUpdBatchBulkOpt(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                this.setState({
                    isShowSelected: false,
                    isShowProgress: tabKey,
                }, () => {
                    this.getRecordData();
                })
            } else {
                this.setState({
                    isShowProgress: -1,
                    optType: ''
                })
                this.props.toggleToast(res.msg, true);
            }
        })
    }

    // 删除订阅器
    deleteMetaTimerArr = () => {
        timeMetaArr.map(timer => {
            clearInterval(timer);
            timeMetaArr.pop();
            return false;
        })
    }

    // 删除开关订阅器
    deleteSwitchTimerArr = () => {
        switchTimerArr.map(timer => {
            clearInterval(timer);
            switchTimerArr.pop();
            return false;
        })
    }

    // 下拉
    toggleMetaMore = (type) => {
        let { metaMoreState } = this.state;
        this.setState({
            metaMoreState: metaMoreState === type ? "" : type
        })
    }

    // 打开编辑弹窗
    openMetaEditModal = (type, _state) => {
        this.setState({
            [type]: _state,
            metaMoreState: "",
        })
    }

    // 返回
    goBack = () => {
        utils.routeJump(this, '/searchAppearance')
    }

    // 关闭cw广告
    closeImageCwAdver = () => {
        this.setState({
            isShowCwAdverMetatag: false,
        }, () => {
            this.requestStateSet('cwAdverMetatagState', 1);
        })
    }

    // 发送请求
    requestStateSet = async (type, state) => {
        const params = {
            name: `${type}`,
            st: Number(state),
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    componentWillUnmount() {
        // count = 0;
        this.deleteMetaTimerArr();
        this.deleteSwitchTimerArr();
        timerArr.map(timer => {
            clearInterval(timer);
            timerArr.pop();
            return false;
        })
        this.setState = () => false;
    }

    render() {
        const {
            loadingTag,
            loadingPage,
            altProAutoAdd,
            altColAutoAdd,
            altBlogAutoAdd,
            altProAutoAddLoading,
            altColAutoAddLoading,
            altBlogAutoAddLoading,
            tagActive,
            productTitleList,
            productDescList,
            colTitleList,
            colDescList,
            blogTitleList,
            blogDescList,
            proTitleTag,
            proDescTag,
            colTitleTag,
            colDescTag,
            blogTitleTag,
            blogDescTag,
            ProductTitleTagBulkPop,
            ProductDescTagBulkPop,
            ColTitleTagBulkPop,
            ColDescTagBulkPop,
            BlogTitleTagBulkPop,
            BlogDescTagBulkPop,
            // isShowProductPreview,
            // isShowColPreview,
            // isShowBlogPreview,
            productDeatial,
            colllectDeatial,
            blogDeatial,
            updProductPreviewStatus,
            updCollectionPreviewStatus,
            updBlogPreviewStatus,
            productOverwrite,
            collectionOverwrite,
            blogOverwrite,
            productSetLoading,
            collectionSetLoading,
            blogSetLoading,
            productSetDisabled,
            collectionSetDisabled,
            blogSetDisabled,
            queryValue,
            tabKey,
            page,
            pageSize,
            current_PageSize,
            total,
            recordLoading,
            recordData,
            recordHeadings,
            blHasPrevious,
            blHasNext,
            isShowProgress,
            progressCp,
            progressAll,
            optType,
            batchLoading,
            queryLoading,
            shopname,
            addTagsProTitle,
            addTagsProDesc,
            addTagsColTitle,
            addTagsColDesc,
            addTagsBlogTitle,
            addTagsBlogDesc,
            isLocalStorage,
            questionList,
            iscacheLoading,
            // level,

            productTitle,
            productDesc,
            collectionTitle,
            collectionDesc,
            blogTitle,
            blogDesc,
            metaMoreState,
            productEditModal,
            collectionEditModal,
            blogEditModal,

            isShowCwAdverMetatag,
        } = this.state;

        // 提示icon
        const warnIcon = <svg t="1695125243916" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11078" width="20" height="20"><path d="M959.256366 512C959.256366 264.98713 759.01287 64.743634 512 64.743634 264.98713 64.743634 64.743634 264.98713 64.743634 512 64.743634 759.01287 264.98713 959.256366 512 959.256366 759.01287 959.256366 959.256366 759.01287 959.256366 512L959.256366 512 959.256366 512 959.256366 512 959.256366 512 959.256366 512ZM117.36203 512C117.36203 294.047467 294.047467 117.36203 512 117.36203 729.952533 117.36203 906.63797 294.047467 906.63797 512 906.63797 729.952533 729.952533 906.63797 512 906.63797 294.047467 906.63797 117.36203 729.952533 117.36203 512L117.36203 512 117.36203 512 117.36203 512 117.36203 512 117.36203 512Z" fill="#FC5143" p-id="11079"></path><path d="M484.457558 599.560299C484.457558 622.580963 495.008537 634.091122 516.110812 634.091122 537.213087 634.091122 547.764066 622.580963 547.764066 599.560299L547.764066 280.150193C547.764066 257.129529 537.213087 245.61937 516.110812 245.61937 495.008537 245.61937 484.457558 257.129529 484.457558 280.150193L484.457558 599.560299ZM478.702421 740.561158C480.62081 763.581821 493.090149 775.091981 516.110812 775.091981 539.131476 775.091981 551.600815 763.581821 553.519203 740.561158 551.600815 717.540494 539.131476 705.071155 516.110812 703.152767 493.090149 705.071155 480.62081 717.540494 478.702421 740.561158L478.702421 740.561158Z" fill="#FC5143" p-id="11080"></path></svg>

        // 格式化集合
        const productTitleTags = {
            "%product_title%": "<span>Product title</span>",
            "%product_vendor%": "<span>Product vendor</span>",
            "%product_type%": "<span>Product type</span>",
            "%price%": "<span>Price</span>",
            "%shopname%": "<span>Shop name</span>",
            "2025": "<span>2025</span>",
        }
        const productDescTags = {
            "%product_title%": "<span>Product title</span>",
            "%product_description%": "<span>Product description</span>",
            "%product_vendor%": "<span>Product vendor</span>",
            "%product_type%": "<span>Product type</span>",
            "%price%": "<span>Price</span>",
            "%shopname%": "<span>Shop name</span>",
        }
        const collectionTitleTags = {
            "%collection_title%": "<span>Collection title</span>",
            "%shopname%": "<span>Shop name</span>",
        }
        const collectionDescTags = {
            "%collection_title%": "<span>Collection title</span>",
            "%collection_description%": "<span>Collection description</span>",
            "%shopname%": "<span>Shop name</span>",
        }
        const blogTitleTags = {
            "%article_author%": "<span>Article author</span>",
            "%article_title%": "<span>Article title</span>",
            "%article_tags%": "<span>Article tags</span>",
            "%shopname%": "<span>Shop name</span>",
        }
        const blogDescTags = {
            "%article_author%": "<span>Article author</span>",
            "%article_description%": "<span>Article description</span>",
            "%article_title%": "<span>Article title</span>",
            "%article_tags%": "<span>Article tags</span>",
            "%shopname%": "<span>Shop name</span>",
        }


        // 数据转换
        const TracelessTagsData = (type, data) => {
            let val = cloneDeep(data);
            val = val.replace(/[\n\u200B]/g, '');
            if (type === 'proTitle') {
                val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                    .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                    .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                    .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%')
                    .replace(/\[\[{"value":"2025"}\]\]/g, '2025')
            } else if (type === 'proDesc') {
                val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                    .replace(/\[\[{"value":"Product description"}\]\]/g, '%product_description%')
                    .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                    .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                    .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
            } else if (type === 'colTitle') {
                val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
            } else if (type === 'colDesc') {
                val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                    .replace(/\[\[{"value":"Collection description"}\]\]/g, '%collection_description%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
            } else if (type === 'blogTitle') {
                val = val.replace(/\[\[{"value":"Article author"}\]\]/g, '%article_author%')
                    .replace(/\[\[{"value":"Article title"}\]\]/g, '%article_title%')
                    .replace(/\[\[{"value":"Article tags"}\]\]/g, '%article_tags%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
            } else if (type === 'blogDesc') {
                val = val.replace(/\[\[{"value":"Article author"}\]\]/g, '%article_author%')
                    .replace(/\[\[{"value":"Article description"}\]\]/g, '%article_description%')
                    .replace(/\[\[{"value":"Article title"}\]\]/g, '%article_title%')
                    .replace(/\[\[{"value":"Article tags"}\]\]/g, '%article_tags%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shopname%');
            } else { }
            return val;
        }


        // 预览模块
        const wordBall = <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="26" height="26" rx="13" fill="#E2EEFF" />
            <path d="M17.13 17.273C16.948 16.713 16.423 16.3 15.8 16.3H15.1V14.2C15.1 14.0143 15.0262 13.8363 14.895 13.705C14.7637 13.5738 14.5857 13.5 14.4 13.5H10.2V12.1H11.6C11.7857 12.1 11.9637 12.0262 12.095 11.895C12.2263 11.7637 12.3 11.5857 12.3 11.4V10H13.7C14.0713 10 14.4274 9.8525 14.6899 9.58995C14.9525 9.3274 15.1 8.9713 15.1 8.6V8.313C15.9375 8.65066 16.6808 9.18623 17.2661 9.87388C17.8514 10.5615 18.2614 11.3808 18.4609 12.2615C18.6605 13.1422 18.6436 14.0582 18.4118 14.9309C18.18 15.8037 17.7402 16.6073 17.13 17.273ZM12.3 19.051C9.535 18.708 7.4 16.356 7.4 13.5C7.4 13.066 7.456 12.646 7.547 12.247L10.9 15.6V16.3C10.9 16.6713 11.0475 17.0274 11.3101 17.2899C11.5726 17.5525 11.9287 17.7 12.3 17.7M13 6.5C12.0807 6.5 11.1705 6.68106 10.3212 7.03284C9.47194 7.38463 8.70026 7.90024 8.05025 8.55025C6.7375 9.86301 6 11.6435 6 13.5C6 15.3565 6.7375 17.137 8.05025 18.4497C8.70026 19.0998 9.47194 19.6154 10.3212 19.9672C11.1705 20.3189 12.0807 20.5 13 20.5C14.8565 20.5 16.637 19.7625 17.9497 18.4497C19.2625 17.137 20 15.3565 20 13.5C20 12.5807 19.8189 11.6705 19.4672 10.8212C19.1154 9.97194 18.5998 9.20026 17.9497 8.55025C17.2997 7.90024 16.5281 7.38463 15.6788 7.03284C14.8295 6.68106 13.9193 6.5 13 6.5Z" fill="#0060F0" />
        </svg>
        const PreviewBox = (type, detail, title, description) => {
            return <div className='preview_main'>
                <BlockStack gap={100}>
                    <div className='flex_layout'>
                        <span>{wordBall}</span>
                        <div className='user_domain'>
                            <Text as="p" fontWeight="semibold">{shopname}</Text>
                            <Tooltip content={detail.url}>
                                <Text as="p" color="subdued">{detail.url}</Text>
                            </Tooltip>
                        </div>

                    </div>
                    <div className='user_store_info'>
                        <h2 className='ellipsis_2'>
                            {
                                type === 1 ? title.replace(/\[\[{"value":"Product title"}\]\]/g, detail.title)
                                    .replace(/\[\[{"value":"Product vendor"}\]\]/g, detail.vendor)
                                    .replace(/\[\[{"value":"Product type"}\]\]/g, detail.type)
                                    .replace(/\[\[{"value":"Price"}\]\]/g, detail.price)
                                    .replace(/\[\[{"value":"Shop name"}\]\]/g, shopname)
                                    .replace(/\[\[{"value":"2025"}\]\]/g, 2025) :
                                    type === 2 ? title.replace(/\[\[{"value":"Collection title"}\]\]/g, detail.title)
                                        .replace(/\[\[{"value":"Shop name"}\]\]/g, shopname) :
                                        type === 3 ? title.replace(/\[\[{"value":"Article author"}\]\]/g, detail.author)
                                            .replace(/\[\[{"value":"Article title"}\]\]/g, detail.title)
                                            .replace(/\[\[{"value":"Article tags"}\]\]/g, detail.tags)
                                            .replace(/\[\[{"value":"Shop name"}\]\]/g, shopname) : null
                            }
                        </h2>
                        <span className='ellipsis_3'>
                            {
                                type === 1 ? description.replace(/\[\[{"value":"Product title"}\]\]/g, detail.title)
                                    .replace(/\[\[{"value":"Product description"}\]\]/g, detail.description)
                                    .replace(/\[\[{"value":"Product vendor"}\]\]/g, detail.vendor)
                                    .replace(/\[\[{"value":"Product type"}\]\]/g, detail.type)
                                    .replace(/\[\[{"value":"Price"}\]\]/g, detail.price)
                                    .replace(/\[\[{"value":"Shop name"}\]\]/g, shopname) :
                                    type === 2 ? description.replace(/\[\[{"value":"Collection title"}\]\]/g, detail.title)
                                        .replace(/\[\[{"value":"Collection description"}\]\]/g, detail.description)
                                        .replace(/\[\[{"value":"Shop name"}\]\]/g, shopname) :
                                        type === 3 ? description.replace(/\[\[{"value":"Article author"}\]\]/g, detail.author)
                                            .replace(/\[\[{"value":"Article description"}\]\]/g, detail.description)
                                            .replace(/\[\[{"value":"Article title"}\]\]/g, detail.title)
                                            .replace(/\[\[{"value":"Article tags"}\]\]/g, detail.tags)
                                            .replace(/\[\[{"value":"Shop name"}\]\]/g, shopname) : null
                            }
                        </span>
                    </div>
                </BlockStack>
            </div>
        }

        // 编辑弹窗 - 产品
        const productMetaEditModal = <Modal
            open={productEditModal}
            title={t("Edit rule for product")}
            onClose={() => this.openMetaEditModal("productEditModal", false)}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    <div className='tag_product_box tag_block'>
                        {
                            (loadingTag || iscacheLoading) ? <div className='tag_shade_block'>
                                <BlockStack gap={200}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </div> : null
                        }
                        <BlockStack gap={200}>
                            <div>
                                <div className='tag_title flex_layout'>
                                    <span>{t("Meta title")}</span>
                                    <Button variant='plain' onClick={() => this.setDefaultRule('proTitleTag')}>{t("use default rule")}</Button>
                                </div>
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"ProductTitleTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={proTitleTag}
                                            actionList={productTitleList}
                                            isShowSelectPop={ProductTitleTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'proTitleTag')}
                                            addTags={addTagsProTitle}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("ProductTitleTagBulk")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"ProductTitleTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('proTitle', proTitleTag)}
                                            actionList={productTitleList}
                                            isShowSelectPop={ProductTitleTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'proTitleTag')}
                                        />
                                }
                            </div>
                            <div>
                                <div className='tag_title flex_layout'>
                                    <span>{t("Meta description")}</span>
                                    <Button variant='plain' onClick={() => this.setDefaultRule('proDescTag')}>{t("use default rule")}</Button>
                                </div>
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"ProductDescTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={proDescTag}
                                            actionList={productDescList}
                                            isShowSelectPop={ProductDescTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'proDescTag')}
                                            addTags={addTagsProDesc}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("ProductDescTagBulk")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"ProductDescTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('proDesc', proDescTag)}
                                            actionList={productDescList}
                                            isShowSelectPop={ProductDescTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'proDescTag')}
                                        />
                                }
                            </div>
                            <div className='preview_box'>
                                <div className='flex_layout pre_opera'>
                                    <Checkbox id='productOverwrite' disabled={iscacheLoading} checked={productOverwrite} label={t("Overwrite existing meta tags")} onChange={this.checkOverwriteState} />
                                </div>
                            </div>
                        </BlockStack>
                    </div>
                    <BlockStack gap={200}>
                        <div className='g_preview'>
                            <Text variant="headingMd" as="h2">{t("Search engine preview")}</Text>
                            <div className='update_preview'>
                                {
                                    !updProductPreviewStatus ? <Button variant='plain' onClick={() => this.updBulkEditPreview(1)}>{t("update preview")}</Button> : <Spinner size='small' />
                                }
                            </div>
                        </div>
                        {PreviewBox(1, productDeatial, proTitleTag, proDescTag)}
                    </BlockStack>
                    <div className='row_line_05'></div>
                    <div className='flex_layout save_setting_btn'>
                        <Button onClick={() => this.openMetaEditModal("productEditModal", false)}>{t("Cancel")}</Button>
                        <Button id='productSet' variant='primary' disabled={altProAutoAddLoading || productSetDisabled || iscacheLoading} loading={productSetLoading} onClick={() => this.saveSettingData('productSet', 'productEditModal')}>{t("Save")}</Button>
                    </div>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 编辑弹窗 - 集合
        const collectionMetaEditModal = <Modal
            open={collectionEditModal}
            title={t("Edit rule for collection")}
            onClose={() => this.openMetaEditModal("collectionEditModal", false)}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    <div className='tag_collection_box tag_block'>
                        {
                            (loadingTag || iscacheLoading) ? <div className='tag_shade_block'>
                                <BlockStack gap={200}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </div> : null
                        }
                        <BlockStack gap={500}>
                            <div>
                                <div className='tag_title flex_layout'>
                                    <span>{t("Meta title")}</span>
                                    <Button variant='plain' onClick={() => this.setDefaultRule('colTitleTag')}>{t("use default rule")}</Button>
                                </div>
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"ColTitleTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={colTitleTag}
                                            actionList={colTitleList}
                                            isShowSelectPop={ColTitleTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'colTitleTag')}
                                            addTags={addTagsColTitle}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("ColTitleTagBulk")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"ColTitleTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('colTitle', colTitleTag)}
                                            actionList={colTitleList}
                                            isShowSelectPop={ColTitleTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'colTitleTag')}
                                        />
                                }
                            </div>
                            <div>
                                <div className='tag_title flex_layout'>
                                    <span>{t("Meta description")}</span>
                                    <Button variant='plain' onClick={() => this.setDefaultRule('colDescTag')}>{t("use default rule")}</Button>
                                </div>
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"ColDescTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={colDescTag}
                                            actionList={colDescList}
                                            isShowSelectPop={ColDescTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'colDescTag')}
                                            addTags={addTagsColDesc}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("ColDescTagBulk")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"ColDescTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('colDesc', colDescTag)}
                                            actionList={colDescList}
                                            isShowSelectPop={ColDescTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'colDescTag')}
                                        />
                                }
                            </div>
                            <div className='preview_box'>
                                <div className='flex_layout pre_opera'>
                                    <Checkbox id='collectionOverwrite' disabled={iscacheLoading} checked={collectionOverwrite} label={t("Overwrite existing meta tags")} onChange={this.checkOverwriteState} />
                                    {/* <Button onClick={() => this.openPreview('isShowColPreview')} disabled={iscacheLoading} variant='plain'>{!isShowColPreview ? t("Show search result preview") : t("Hide search result preview")}</Button> */}
                                </div>
                            </div>
                        </BlockStack>
                    </div>
                    <BlockStack gap={400}>
                        <div className='g_preview'>
                            <Text variant="headingMd" as="h2">{t("Search engine preview")}</Text>
                            <div className='update_preview'>
                                {
                                    !updCollectionPreviewStatus ? <Button variant='plain' onClick={() => this.updBulkEditPreview(2)}>{t("update preview")}</Button> : <Spinner size='small' />
                                }
                            </div>
                        </div>
                        {PreviewBox(2, colllectDeatial, colTitleTag, colDescTag)}
                    </BlockStack>
                    <div className='row_line_05'></div>
                    <div className='flex_layout save_setting_btn'>
                        <Button onClick={() => this.openMetaEditModal("collectionEditModal", false)}>{t("Cancel")}</Button>
                        <Button id='collectionSet' variant='primary' disabled={altColAutoAddLoading || collectionSetDisabled || iscacheLoading} loading={collectionSetLoading} onClick={() => this.saveSettingData('collectionSet', 'collectionEditModal')}>{t("Save")}</Button>
                    </div>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 编辑弹窗 - 博客
        const blogMetaEditModal = <Modal
            open={blogEditModal}
            title={t("Edit rule for blog")}
            onClose={() => this.openMetaEditModal("blogEditModal", false)}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    <div className='tag_collection_box tag_block'>
                        {
                            (loadingTag || iscacheLoading) ? <div className='tag_shade_block'>
                                <BlockStack gap={200}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </div> : null
                        }
                        <BlockStack gap={500}>
                            <div>
                                <div className='tag_title flex_layout'>
                                    <span>{t("Meta title")}</span>
                                    <Button variant='plain' onClick={() => this.setDefaultRule('blogTitleTag')}>{t("use default rule")}</Button>
                                </div>
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"BlogTitleTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={blogTitleTag}
                                            actionList={blogTitleList}
                                            isShowSelectPop={BlogTitleTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'blogTitleTag')}
                                            addTags={addTagsBlogTitle}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("BlogTitleTagBulk")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"BlogTitleTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('blogTitle', blogTitleTag)}
                                            actionList={blogTitleList}
                                            isShowSelectPop={BlogTitleTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'blogTitleTag')}
                                        />
                                }
                            </div>
                            <div>
                                <div className='tag_title flex_layout'>
                                    <span>{t("Meta description")}</span>
                                    <Button variant='plain' onClick={() => this.setDefaultRule('blogDescTag')}>{t("use default rule")}</Button>
                                </div>
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"BlogDescTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={blogDescTag}
                                            actionList={blogDescList}
                                            isShowSelectPop={BlogDescTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'blogDescTag')}
                                            addTags={addTagsBlogDesc}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("BlogDescTagBulk")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"BlogDescTagBulk"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('blogDesc', blogDescTag)}
                                            actionList={blogDescList}
                                            isShowSelectPop={BlogDescTagBulkPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'blogDescTag')}
                                        />
                                }
                            </div>
                            <div className='preview_box'>
                                <div className='flex_layout pre_opera'>
                                    <Checkbox id='blogOverwrite' disabled={iscacheLoading} checked={blogOverwrite} label={t("Overwrite existing meta tags")} onChange={this.checkOverwriteState} />
                                    {/* <Button onClick={() => this.openPreview('isShowBlogPreview')} disabled={iscacheLoading} variant='plain'>{!isShowBlogPreview ? t("Show search result preview") : t("Hide search result preview")}</Button> */}
                                </div>
                            </div>
                        </BlockStack>
                    </div>
                    <BlockStack gap={400}>
                        <div className='g_preview'>
                            <Text variant="headingMd" as="h2">{t("Search engine preview")}</Text>
                            <div className='update_preview'>
                                {
                                    !updBlogPreviewStatus ? <Button variant='plain' onClick={() => this.updBulkEditPreview(3)}>{t("update preview")}</Button> : <Spinner size='small' />
                                }
                            </div>
                        </div>
                        {PreviewBox(3, blogDeatial, blogTitleTag, blogDescTag)}
                    </BlockStack>
                    <div className='row_line_05'></div>
                    <div className='flex_layout save_setting_btn'>
                        <Button onClick={() => this.openMetaEditModal("blogEditModal", false)}>{t("Cancel")}</Button>
                        <Button id='blogSet' variant='primary' disabled={altBlogAutoAddLoading || blogSetDisabled || iscacheLoading} loading={blogSetLoading} onClick={() => this.saveSettingData('blogSet', 'blogEditModal')}>{t("Save")}</Button>
                    </div>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 预览
        const MetaPreivewBlock = (type, modal, title, desc, overwrite, titleArr, descArr) => {
            return <div className="meta-tags-container">
                <div className="meta-section">
                    <div className="meta-header">{t("Meta title")}</div>
                    <div className='meta-format' dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            title.replace(
                                new RegExp(Object.keys(titleArr).join("|"), "g"),
                                (matched) => titleArr[matched]
                            )
                        )
                    }} />
                </div>
                <div className="meta-section">
                    <div className="meta-header">{t("Meta description")}</div>
                    <div className='meta-format' dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            desc.replace(
                                new RegExp(Object.keys(descArr).join("|"), "g"),
                                (matched) => descArr[matched]
                            )
                        )
                    }} />
                </div>
                <div className="meta-section" style={{ borderRight: 'none' }}>
                    <div className="section-with-controls">
                        <div className="meta-header">{t("Overwrite existing meta tags")}</div>
                        <div className="controls">
                            {
                                overwrite ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
                            }
                        </div>
                    </div>
                </div>
                <div className='meta-more'>
                    <Popover
                        active={metaMoreState === type}
                        activator={
                            <span className='meta-more' onClick={() => this.toggleMetaMore(type)}><Icon source={MobileHorizontalDotsMajor} tone='base' /></span>
                        }
                        onClose={() => this.toggleMetaMore("")}
                    >
                        <ActionList
                            actionRole="menuitem"
                            items={[
                                {
                                    content: t("Edit"),
                                    onAction: () => this.openMetaEditModal(modal, true),
                                },
                            ]}
                        />
                    </Popover>
                </div>
            </div>
        }

        // cw广告
        const cwAdver = isShowCwAdverMetatag && <Card>
            <div className='cw_adver flex_layout speedopt_adver'>
                <span onClick={this.closeImageCwAdver}><Icon source={CancelMajor} tone="base" /></span>
                <div className='flex_layout'>
                    <img src='/extra_app/langwill_cw.png' alt='' />
                    <p className='cw_adver_desc'>Bulk translate Meta Tags with Langwill to improve multilingual SEO performance.</p>
                </div>
                <Button onClick={() => { window.open("https://share.channelwill.com/app/1668099de330f65wR9") }}>Try Langwill Free</Button>
            </div>
        </Card>

        // 类型数据card
        const CardContent = <div style={{ position: 'relative' }}>
            <BlockStack gap={400}>
                <Card>
                    <div className='card_state_meta'>
                        <Text variant="headingMd" as="h2">{t("Product")}</Text>
                        {
                            altProAutoAdd ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
                        }
                        <div className='org_switch_meta'>
                            {(altProAutoAddLoading || iscacheLoading) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                            <Switch disabled={Boolean(iscacheLoading)} onChange={() => this.autoSwitchChange('altProAutoAdd')} checked={altProAutoAdd} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                        </div>
                    </div>
                    <Text as="p" tone="subdued" variant='bodyMd'>{t("When enable, SEOAnt automatically generates product meta titles and descriptions based on predefined rules.")}</Text>
                    {MetaPreivewBlock("product", "productEditModal", productTitle, productDesc, productOverwrite, productTitleTags, productDescTags)}
                </Card>
                <Card>
                    <div className='card_state_meta'>
                        <Text variant="headingMd" as="h2">{t("Collection")}</Text>
                        {
                            altColAutoAdd ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
                        }
                        <div className='org_switch_meta'>
                            {(altColAutoAddLoading || iscacheLoading) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                            <Switch disabled={Boolean(iscacheLoading)} onChange={() => this.autoSwitchChange('altColAutoAdd')} checked={altColAutoAdd} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                        </div>
                    </div>
                    <Text as="p" tone="subdued" variant='bodyMd'>{t("When enable, SEOAnt automatically generates collection meta titles and descriptions based on predefined rules.")}</Text>
                    {MetaPreivewBlock("collection", "collectionEditModal", collectionTitle, collectionDesc, collectionOverwrite, collectionTitleTags, collectionDescTags)}
                </Card>
                <Card>
                    <div className='card_state_meta'>
                        <Text variant="headingMd" as="h2">{t("Blog")}</Text>
                        {
                            altBlogAutoAdd ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
                        }
                        <div className='org_switch_meta'>
                            {(altBlogAutoAddLoading || iscacheLoading) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                            <Switch disabled={Boolean(iscacheLoading)} onChange={() => this.autoSwitchChange('altBlogAutoAdd')} checked={altBlogAutoAdd} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                        </div>
                    </div>
                    <Text as="p" tone="subdued" variant='bodyMd'>{t("When enable, SEOAnt automatically generates blog meta titles and descriptions based on predefined rules.")}</Text>
                    {MetaPreivewBlock("blog", "blogEditModal", blogTitle, blogDesc, blogOverwrite, blogTitleTags, blogDescTags)}
                </Card>
                {cwAdver}
            </BlockStack>
        </div>

        // 表格批量操作选项
        const promotedBulkActions = [
            {
                content: t("Restore all"),
                onAction: () => this.handleObjState('restore', true),
            },
            {
                content: t("Re-optimize"),
                onAction: () => this.handleObjState('optimize', true),
            },
        ];
        // 分页
        const startNum = (((page - 1) * pageSize) + 1);
        const endNum = (page * pageSize > total) ? total : page * pageSize;
        const footerContentText = window.innerWidth > 550 ? <FooterPageSelect current_PageSize={current_PageSize} changePageSize={this.changePageSizeData} startNum={startNum} endNum={endNum} total={total} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
        const FooterPageBlock = <Pagination
            label={footerContentText}
            hasPrevious={blHasPrevious}
            onPrevious={() => this.changeTablePage(page - 1)}
            hasNext={blHasNext}
            onNext={() => this.changeTablePage(page + 1)}
        />
        // 历史记录
        const CardHistory = <div style={{ marginTop: '2rem' }} className='meta_opt_history'>
            <BlockStack gap={400}>
                <Text variant="headingLg" as="h2">{t("Optimization History")}</Text>
                <Card padding={0}>
                    <TableFilters
                        itemStrings={[
                            t("Product"),
                            t("Collection"),
                            t("Blog"),
                        ]}
                        queryValue={queryValue}
                        typeSelected={tabKey}
                        setSelectedTabsIndex={(e) => this.handleTypeTabsChange(e)}
                        setQueryValue={(v) => this.setQueryValue(v)}
                        setIssueTypeChange={this.setIssueTypeChange}
                        loading={queryLoading || recordLoading}
                    />
                    {
                        (isShowProgress !== -1 && isShowProgress === tabKey) ? <div className='opt_progress_hitory_meta Every_Card_Space'>
                            <div className='flex_layout'>
                                <div className='flex_layout auto_opt_tip'>
                                    <Text variant="headingXs" as="h6">
                                        {
                                            optType === 'restored' ? t("Restoring") : t("Re-optimizing")
                                        }
                                    </Text>
                                    <Spinner size='small' />
                                </div>
                                <span>{t("completed")}/{t("all")}:&nbsp;&nbsp;{progressCp}/{progressAll}</span>
                            </div>
                            {
                                progressAll > 0 && <ProgressBar progress={Number(((progressCp / progressAll) * 100).toFixed(0))} size='small' />
                            }

                        </div> : null
                    }

                    {recordLoading ? <div className='flex_layout table_loading_meta'>
                        <Spinner />
                    </div> :
                        <IndexTableMetaBox
                            tabKey={tabKey}
                            headings={recordHeadings}
                            dataList={recordData}
                            checkState={false}
                            total={total}
                            loading={batchLoading}
                            obj_name={tabKey === 0 ? 'products' : tabKey === 1 ? 'collections' : 'blogs'}
                            isShowProgress={isShowProgress}
                            getTableItemState={this.getTableItemState}
                            aloneBatchOpt={this.aloneBatchOpt}
                            promotedBulkActions={promotedBulkActions}
                        />
                    }
                    {recordData.length > 0 && <div className='sticky_footer justify_center'>{FooterPageBlock}</div>}
                </Card>
            </BlockStack>
        </div>

        // FAQ
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 等级
        // const lockIcon = (plan = 1) => {
        //     return <div className='PAY_ICON'>
        //         {plan === 2 ? t("Pro plan unlock") : t("Pre plan unlock")} <Icon source={LockMajor} tone="base" />
        //     </div>
        // }

        // 最终内容
        const pageContentLast = loadingPage ? <SkeltonLoading /> :
            <Page
            // title={<div className='pageLayout' style={{ display: "flex", alignItems: "center" }}>
            //     {t("Bulk-edit Meta Tags")}&nbsp;
            //     <Tooltip content={t("Meta titles and descriptions briefly summarize your webpage content, helping search engines understand your page better. Let SEOAnt auto-optimize Meta Tags in bulk for you.")}>
            //         {<Icon source={QuestionMarkInverseMajor} />}
            //     </Tooltip>
            //     {(level === 1 && false) && lockIcon(2)}
            // </div>}
            // backAction={{
            //     content: t("Bulk-edit Meta Tags"),
            //     onAction: this.goBack,
            // }}
            >
                <title>SEOAnt - Bulk-edit Meta Tags</title>

                {CardContent}
                <BlockStack gap={400}>
                    {CardHistory}
                    {FrequentlyItems}
                </BlockStack>

                {/* 底部 */}
                {FooterHelpBox}
            </Page>

        return (
            <div className="Bulk-Edit_MetaTags">
                {pageContentLast}
                {productMetaEditModal}
                {collectionMetaEditModal}
                {blogMetaEditModal}
            </div>
        )
    }

}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['MetaTags', data]));
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },
})

ManualBulkEdit = connect(
    mapStateToProps,
    mapDispatchToProps
)(ManualBulkEdit);


export default withRouter(ManualBulkEdit);